interface ExaminingTeamMember {
    pesel: string;
    number: string;
}

interface ExaminerStructure {
    chairman: ExaminingTeamMember;
    examiners: ExaminingTeamMember[];
}

interface ExamTaskGroupStructure {
    examTaskGroupName: string;
    examinerStructures: ExaminerStructure[];
}

export interface ImportExaminerStructureRequest {
    deleteExistingStructure?: boolean;
    examSheetCode: string;
    examTaskGroupStructures: ExamTaskGroupStructure[];
}

export enum ImportExaminerStructureStatus {
  Success,
  EmptyRequest,
  SheetNotConfigured,
  ExaminersAlreadyStartedAssessment,
  NoExaminerStructure,
  ExamSheetCodeNotExist,
  ExamTaskGroupsNotExist,
  ExaminersNotExists,
  ExaminersWithoutNumber,
  ExamTaskGroupExaminersDuplicated,
  ExaminersFromAnotherCommittee,
  CommitteeExamTaskGroupCoordinatorNotExist,
  Error,
  AnotherUserRunImport,
}

export interface ImportExaminerStructureResponse {
    status: ImportExaminerStructureStatus;
    examTaskGroups: string[];
    examiners: string[]
}